export default __webpack_public_path__ + "static/media/SVGFees.519e76bc.svg";